export const PADDING = '16px';
export const CATEGORY_SEPARATOR = ' \u2022 ';
export const CLOSING_SOON_MINUTES = 30;
